import React, { Component } from 'react';
import { Load, LabelWithArrow } from './common/basic';
import DatePicker from './common/datepicker';
import CSVExport from './common/CSVExport';
import { TableHeaderColumn } from 'react-bootstrap-table';
import DataGrid from './common/dataGrid';
import UserSearch from './common/userSearch';
import DropDown from './common/dropDown';
import { CheckBox, ApplyAndReset } from './common/forms';
import moment from 'moment';
import enums from '../config/enums';
import '../public/less/forms.less';
import dateHelper from '../helpers/date.js';

var MoreDetailsContainer = React.createClass({
    MoreDetailsRow: function (key, data) {
        return <div key={key}>{data}</div>;
    },
    createContainer: function (data) {
        var columnData = [];
        for (var prop in data) {
            var rowData = prop + " = " + data[prop];
            columnData.push(this.MoreDetailsRow(prop, rowData));
        }
        return columnData;
    },
    render: function () {
        return (
            <div>{this.createContainer(this.props.data)}</div>
        )
    }
});

// Search Panel
class LogSearch extends Component {

    constructor(props) {
        super(props);

        this.state = getDefaultParams();

        this.operationChanged = this
            .operationChanged
            .bind(this);
           
        this.getParams = this.getParams.bind(this);
    };

    getSearchParams() {
        var params = this.state;

        params.user = this
            ._userSearch
            .getUser();

        return params;
    }

    setDefault(params) {
        this.setState(params);

        this._deviceActivites.resetSelected();
        this._patientActivites.resetSelected();

        this._LLLT.unCheck();
        this._RF.unCheck();
        this._ELP.unCheck();
        this._Sebum.unCheck();
        this._Elasticity.unCheck();
        this._Humidity.unCheck();
    }

    setSearchParams(params) {
        this.setState(params);
    }

    operationChanged(id, isChecked) {
        var operations = this.state.operationIDs;
        if (!isChecked) {
            var index = operations.indexOf(id);
            if (index > -1) {
                operations.splice(index, 1);
            }
        } else {
            operations.push(id);
        }

        this.setState({ operationIDs: operations })
    }

    changeFrom(date) {
        this.setState({ fromDate: date });
    }

    changeTo(date) {
        this.setState({ toDate: date });
    }

    getParams(params) {
        var newParams = {
            fromDate: dateHelper.fromDateToDBStr(params.fromDate),
            toDate: dateHelper.fromDateToDBStr(params.toDate),
            userText: params.user.text,
            userID: params.user.ID,
            operationIDs: params.operationIDs,
            sortOrder: params.sortOrder,
            sortName: params.sortName,
            pageNumber: params.pageNumber,
            itemsPerPage: params.itemsPerPage
        };
        return newParams;
    }

    render() {
        return (
            <div className='SearchContainer' >
                <div>
                    <div className='row'>
                        <div className='col-md-6 col-xs-12'>
                            <div className='col-xs-5 nowrap right-border no-left-padding'>
                                <DatePicker
                                    className='display-table'
                                    Label='From date'
                                    type="start"
                                    startDate={this.state.fromDate}
                                    endDate={this.state.toDate}
                                    onChange={this
                                        .changeFrom
                                        .bind(this)} />
                                <DatePicker
                                    className='display-table'
                                    Label='To date'
                                    type="end"
                                    startDate={this.state.fromDate}
                                    endDate={this.state.toDate}
                                    ContainerType='input'
                                    onChange={this
                                        .changeTo
                                        .bind(this)} />
                            </div>
                            <div className='col-xs-5 right-border'>
                                <h5>Patient name</h5>
                                <UserSearch
                                    Value={this.state.user}
                                    ref={(userSearch) => { this._userSearch = userSearch; }} />
                                <DropDown
                                    id="Device"
                                    Label="Patient activities"
                                    Data={PatientOptions}
                                    onChange={this.operationChanged}
                                    checkedArray={this.state.operationIDs}
                                    ref={(patientActivites) => { this._patientActivites = patientActivites; }} />
                            </div>
                            <div className='col-xs-2 small-line-break'>
                                <h5>Treatment</h5>
                                <CheckBox
                                    id={enums.LOG_OPERATIONS.LLLT}
                                    onChange={this.operationChanged}
                                    ref={(LLLT) => { this._LLLT = LLLT; }} >LLLT</CheckBox>
                                <CheckBox
                                    id={enums.LOG_OPERATIONS.RF}
                                    onChange={this.operationChanged}
                                    ref={(RF) => { this._RF = RF; }}>RF</CheckBox>
                                <CheckBox
                                    id={enums.LOG_OPERATIONS.EMT}
                                    onChange={this.operationChanged}
                                    ref={(ELP) => { this._ELP = ELP; }}>ELP</CheckBox>
                            </div>
                        </div>
                        <div className='col-md-6 col-xs-12 second-row'>
                            <div className='col-xs-3 right-border small-line-break'>
                                <h5>Measurment</h5>
                                <CheckBox
                                    id={enums.LOG_OPERATIONS.HUMIDITY}
                                    onChange={this.operationChanged}
                                    ref={(Humidity) => { this._Humidity = Humidity; }}>Humidity</CheckBox>
                                <CheckBox
                                    id={enums.LOG_OPERATIONS.SEBUM}
                                    onChange={this.operationChanged}
                                    ref={(Sebum) => { this._Sebum = Sebum; }}>Sebum</CheckBox>
                                <CheckBox
                                    id={enums.LOG_OPERATIONS.ELASTICITY}
                                    onChange={this.operationChanged}
                                    ref={(Elasticity) => { this._Elasticity = Elasticity; }}>Elasticity</CheckBox>
                            </div>
                            <div className='col-xs-3'>
                                <DropDown
                                    id="Device"
                                    Label="Device activities"
                                    checkedArray={this.state.operationIDs}
                                    isChecked={this.isChecked}
                                    Data={DeviceOptions}
                                    onChange={this.operationChanged}
                                    ref={(deviceActivites) => { this._deviceActivites = deviceActivites; }} />
                            </div>


                            <div className='col-xs-4'>
                                <ApplyAndReset
                                    Search={this
                                        .props
                                        .Search
                                        .bind(this)}
                                    ApplyReset={this
                                        .props
                                        .ApplyReset
                                        .bind(this)} />
                            </div>
                            <div className='col-xs-1'>
                                <CSVExport 
                                ajaxUrl='/data/getLogs' 
                                parameters={this.getParams(this.state)} 
                                dbKeys={['ID', 'TimeStamp', 'User', 'SerialNumber', 'Operation', 'Status', 'FirstDetail', 'Details']} 
                                csvKeys={['ID', 'Date', 'Patient name', 'Device info', 'Operation', 'Status', 'Info', 'More Info']}
                                fileName={'Logs_' + dateHelper.fromDateToStrWithTimeForFileName(Date.now()) + '.csv'}/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

module.exports = class Logs extends Component {
    constructor(props) {
        super(props);

        this.state = getDefaultParams();
        this.moreDetailsFormatter = this.moreDetailsFormatter.bind(this);

        this.onSortChange = this.onSortChange.bind(this);
        this.onPageChange = this.onPageChange.bind(this);
        this.onSizePerPageList = this.onSizePerPageList.bind(this);
    }

    isExpandable(row) {
        if (row.Details == null)
            return false;
        return true;
    }

    trClassFormat(row, rowIndex) {
        if (row.isExpanded)
            return 'tr-expanded';

        // row is the current row data
        return rowIndex % 2 === 0
            ? "tr-odd"
            : "tr-even"; // return class name.
    }

    expandComponent(row) {
        var allDetails = JSON.parse(row.Details);

        return (
            <table className='exapandbleRowTable'>
                <tbody>
                    <tr>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td><MoreDetailsContainer data={allDetails} /></td>
                        <td width='19'></td>
                    </tr>
                </tbody>
            </table>
        );
    }

    rowClick(row) {
        if (row.isExpanded == undefined || row.isExpanded == false) {
            row.isExpanded = true;
        }
        else {
            row.isExpanded = false;
        }
    }

    Search() {
        var params = this
            ._logSearch
            .getSearchParams();

        this.setState(params);
        this
            ._dataGrid
            .setNewParameters(this.GetParams(params));
    }

    ApplyReset() {
        this.setState(getDefaultParams());

        this
            ._dataGrid
            .setNewParameters(getDefaultParams());

        this
            ._logSearch
            .setDefault(getDefaultParams());
    }

    GetParams(params) {
        var newParams = {
            fromDate: dateHelper.fromDateToDBStr(params.fromDate),
            toDate: dateHelper.fromDateToDBStr(params.toDate),
            userText: params.user.text,
            userID: params.user.ID,
            operationIDs: params.operationIDs,
            sortOrder: params.sortOrder,
            sortName: params.sortName,
            pageNumber: params.pageNumber,
            itemsPerPage: params.itemsPerPage
        }
        return newParams;
    }

    /* More Details */
    moreDetailsFormatter(cell, row, enumObject, index) {
        if (row.Details == null)
            return (
                <div></div>
            );
        if (row.isExpanded != undefined && row.isExpanded == true) {
            return (
                <div className='MoreInfo' onClick={() => this.rowClick(row)}>-</div>
            );
        }
        else {
            return (
                <div className='MoreInfo' onClick={() => this.rowClick(row)}>+</div>
            );
        }
    }

    onSortChange(sortName, sortOrder) {
        var params = this.state;

        params.sortOrder = sortOrder;
        params.sortName = sortName;

        this.setState({
            sortOrder: sortOrder,
            sortName: sortName,
        });

        this._logSearch.setSearchParams(params);
        this._dataGrid.setNewParameters(this.GetParams(params));
    }

    onPageChange(page, sizePerPage) {
        var params = this.state;

        params.pageNumber = page;
        params.itemsPerPage = sizePerPage;

        this.setState({
            pageNumber: page,
            itemsPerPage: sizePerPage
        });

        this._logSearch.setSearchParams(params);
        this._dataGrid.setNewParameters(this.GetParams(params));
    }

    onSizePerPageList(sizePerPage) {
        var params = this.state;

        params.itemsPerPage = sizePerPage;

        this.setState({
            itemsPerPage: sizePerPage
        });

        this._logSearch.setSearchParams(params);
        this._dataGrid.setNewParameters(this.GetParams(params));
    }

    render() {
        var params = this.GetParams(this.state);
        return (
            <div className='container'>
                <LogSearch
                    ref={(logSearch) => {
                        this._logSearch = logSearch;
                    }}
                    ApplyReset={this
                        .ApplyReset
                        .bind(this)}
                    Search={this
                        .Search
                        .bind(this)} />
                <div>
                    <DataGrid
                        ref={(dataGrid) => {
                            this._dataGrid = dataGrid;
                        }}
                        ajaxUrl='/data/getLogsPaging'
                        ID='grid1'
                        parameters={params}
                        OnClick={this.rowClick}
                        ExpandableRow={this.isExpandable}
                        trClassFormat={this.trClassFormat}
                        ExpandComponent={this.expandComponent}
                        pagination={true}
                        remote={true}
                        onSortChange={this.onSortChange}
                        onPageChange={this.onPageChange}
                        onSizePerPageList={this.onSizePerPageList}
                        totelDataUrl="/data/GetLogCount"
                        page={this.state.pageNumber}
                        sizePerPage={this.state.itemsPerPage}>
                        <TableHeaderColumn isKey hidden dataField='ID' />
                        <TableHeaderColumn dataField='TimeStamp' dataFormat={dateFormatter} dataSort>Date</TableHeaderColumn>
                        <TableHeaderColumn dataField='User' dataSort>Patient name</TableHeaderColumn>
                        <TableHeaderColumn dataField='SerialNumber' dataSort>Device info</TableHeaderColumn>
                        <TableHeaderColumn dataField='Operation' dataSort>Operation</TableHeaderColumn>
                        <TableHeaderColumn dataField='Status' dataSort>Status</TableHeaderColumn>
                        <TableHeaderColumn dataField='FirstDetail'>More Info</TableHeaderColumn>
                        <TableHeaderColumn dataField='' dataFormat={this.moreDetailsFormatter} width='35px'></TableHeaderColumn>
                    </DataGrid>
                </div>
            </div>
        )
    }
};

var DeviceOptions = [
    {
        id: enums.LOG_OPERATIONS.DEVICE_CONNECTED,
        name: 'Device connected'
    }, {
        id: enums.LOG_OPERATIONS.DEVICE_DISCONNECTED,
        name: 'Device disconnected'
    }, {
        id: enums.LOG_OPERATIONS.DEVICE_ERROR,
        name: 'Device error'
    }, {
        id: enums.LOG_OPERATIONS.CHANGE_UNIT,
        name: 'Device replacement'
    }
];

var PatientOptions = [
    {
        id: enums.LOG_OPERATIONS.LOGIN,
        name: 'Login'
    }, {
        id: enums.LOG_OPERATIONS.LOGOUT,
        name: 'Log out'
    }, {
        id: enums.LOG_OPERATIONS.REGISTER,
        name: 'Registration'
    }, {
        id: enums.LOG_OPERATIONS.SUBSCRIPTION,
        name: 'Doctor advice payment'
    }, {
        id: enums.LOG_OPERATIONS.CHAT_WITH_DOCTOR,
        name: 'Chat with doctor'
    }, {
        id: enums.LOG_OPERATIONS.CHANGE_PLAN,
        name: 'Change plan'
    }
];

var date = new Date(),
    y = date.getFullYear(),
    m = date.getMonth();

// don't forget to change the objects (DeviceOptions, PatientOptions etc.) too.
var defaultOperations = [];

function getDefaultParams() {
    const DefaultParams = {
        fromDate: new Date(y, m, 1),
        toDate: new Date(y, m + 1, 0),
        userText: '',
        userID: 0,
        user: {
            ID: 0,
            text: ''
        },
        operationIDs: [],
        sortOrder: 'Desc',
        sortName: 'TimeStamp',
        pageNumber: 0,
        itemsPerPage: 10
    } // create a copy of the array
    DefaultParams.operationIDs = defaultOperations.concat();

    return DefaultParams;
}

function dateFormatter(cell, row) {
    return `${dateHelper.fromDBStrToStrWithTime(cell)}`;
}




// WEBPACK FOOTER //
// ./modules/logs.jsx